import { Link } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { Button } from "../components/ui/Button";
import { apiFetch } from "../api/client";
import { useState } from "react";

export function SettingsPlan() {
  const me = useAuthStore((s) => s.me);
  const [msg, setMsg] = useState<string | null>(null);

  async function checkout(plan: "solo" | "fleet") {
    try {
      const res = await apiFetch<{ url: string }>("/api/v1/billing/checkout", {
        method: "POST",
        body: JSON.stringify({ plan }),
      });
      if (res.url) window.location.href = res.url;
      else setMsg("Checkout created");
    } catch (e) {
      setMsg(e instanceof Error ? e.message : "Checkout failed");
    }
  }

  async function portal() {
    try {
      const res = await apiFetch<{ url: string }>("/api/v1/billing/portal", {
        method: "POST",
        body: "{}",
      });
      if (res.url) window.location.href = res.url;
    } catch (e) {
      setMsg(e instanceof Error ? e.message : "Portal failed");
    }
  }

  return (
    <div className="stack">
      <Link to="/settings" className="muted back-link">
        ← Settings
      </Link>
      <h1 className="screen-title">Plan</h1>
      <div className="card stack">
        <div>
          Current: <strong>{me?.plan.planId}</strong>
          {me?.plan.readOnly ? " (read-only)" : ""}
        </div>
        <div className="muted">
          Sub status: {me?.subscription?.status ?? "none"}
        </div>
        <div className="row">
          <Button variant="primary" onClick={() => void checkout("solo")}>
            Solo $15/mo
          </Button>
          <Button onClick={() => void checkout("fleet")}>Fleet $12/seat</Button>
          <Button variant="ghost" onClick={() => void portal()}>
            Billing portal
          </Button>
        </div>
        {msg ? <p>{msg}</p> : null}
      </div>
    </div>
  );
}
